/**
 * Handles the carousel functionality.
 */

if ( document.readyState === 'loading' ) {
	// The DOM has not yet been loaded.
	document.addEventListener( 'DOMContentLoaded', initialiseCarousel );
} else {
	// The DOM has already been loaded.
	initialiseCarousel();
}

/**
 * Iterates through all the carousel found on the current page and instantiates them.
 */
function initialiseCarousel() {
	const items = document.querySelectorAll( '.js-glide-carousel' );

	// No point if no carousels.
	if ( ! items.length ) {
		return;
	}

	for ( let i = 0, len = items.length; i < len; i++ ) {
		carouselHandler( items[ i ] );
	}
}

/**
 * Initialise the glide carousel on page load.
 *
 * @param {object} currentItem DOM element for the current carousel.
 */
function carouselHandler( currentItem ) {
	const settings = getCarouselConfig( currentItem.dataset.carousel_config );
	const slides   = currentItem.querySelectorAll( `.${settings.classes.slide}` );
	const counter  = currentItem.querySelector( `.${settings.classes.counter}` );

	// Initialise carousel.
	let glide = new Glide( currentItem, settings.config ).mount();

	// Update counter after glide is updated.
	glide.on( 'move.after', () => updateCarouselCounter( counter, glide.index, slides.length ) );

	// Destroy carousel on desktop.
	let carouselWasDestroyed = false;

	if ( ! carouselWasDestroyed && window.innerWidth >= 992 ) {
		glide.destroy();
		carouselWasDestroyed = true;
	}

	window.addEventListener( 'resize', () => {
		if ( window.innerWidth >= 992 ) {
			if ( ! carouselWasDestroyed ) {
				glide.destroy();
				carouselWasDestroyed = true;
			}
		} else {
			if ( carouselWasDestroyed ) {
				glide = new Glide( currentItem, settings.config ).mount();
				carouselWasDestroyed = false;

				// Update counter after glide is updated.
				glide.on( 'move.after', () => updateCarouselCounter( counter, glide.index, slides.length ) );
			}
		}
	});
}

/**
 * Updates the carousel counter when the user change slide.
 *
 * @param {object} counter DOM element to update.
 * @param {int}    current Index of the active slide.
 * @param {int}    total   Total count for the current carousel.
 */
function updateCarouselCounter( counter, current, total ) {
	// Index starts from 0 so make sure we increment by 1.
	counter.innerText = `${current + 1} / ${total}`;
}

/**
 * Gets the carousel config based on the passed type
 *
 * @param {string} type Id of the carousel to retrieve the config for
 * @return {object} Glide configuration object
 */
function getCarouselConfig( type ) {
	const sharedConfig = {
		classes: {
			slide: 'js-glide-carousel__slide',
			counter: 'js-glide-carousel__counter',
		},
		config: {
			type: 'slider',
			startAt: 0,
			rewind: true,
		},
	};

	switch ( type ) {
		case "discover-more-block":
			return {
				...sharedConfig,
				config: {
					...sharedConfig.config,
					perView: 3,
					gap: 0,
					breakpoints: {
						992: {
							perView: 2,
							gap: 20,
						},
						768: {
							perView: 1,
							gap: 20,
						},
					},
				},
			};

		case "featured-content-block":
			return {
				...sharedConfig,
				config: {
					...sharedConfig.config,
					perView: 2,
					gap: 10,
					breakpoints: {
						768: {
							perView: 1,
						},
					},
				},
			};
			break;

		case "gallery-block":
			return {
				...sharedConfig,
				classes: {
					...sharedConfig.classes,
					slide: 'blocks-gallery-item',
				},
				config: {
					...sharedConfig.config,
					perView: 2,
					gap: 10,
					breakpoints: {
						768: {
							perView: 1,
						},
					},
				},
			};

		default:
			return {};
	}
};
